module.exports = __webpack_public_path__ + "static/media/file-icon.4bbb67a5.svg";